// src/components/WelcomeTour.js
import React, { useEffect, useRef } from 'react';
import { Joyride } from 'react-joyride';
import api from '../services/api';

export default function WelcomeTour({ run, setRun, user, onComplete }) {
  const joyrideKey = useRef(0);

  useEffect(() => {
    if (run) {
      joyrideKey.current += 1;
    }
  }, [run]);

  const handleJoyrideCallback = async (data) => {
    const { status, type, action } = data;
    console.log('[TOUR DEBUG] Ação capturada pelo Joyride:', { status, type, action });

    const isFinished = ['finished', 'skipped'].includes(status) || type === 'tour:end' || action === 'close';

    if (isFinished) {
      console.log('[TOUR DEBUG] O Joyride mandou fechar! Tentando salvar API silenciosamente...');
      setRun(false); 
      try {
        await api.put('/api/usuarios/me/tour', { tour_concluido: 1 });
        onComplete?.(); 
      } catch (err) {
        console.error('[TOUR DEBUG] Erro silencioso:', err);
      }
    }
  };

  // Declaração dos steps aqui dentro para podermos usar os métodos locais
  const steps = [
    {
      target: 'body',
      placement: 'center',
      title: 'Bem-vindo ao BLB System! 🚀',
      content: 'Olá! Preparamos um tour rápido para você conhecer as ferramentas essenciais do seu novo CRM.',
      disableBeacon: true,
    },
    {
      target: '.notifications-button',
      title: 'Notificações',
      content: 'Aqui você acompanha alertas de aprovações de pedidos (PO) e mensagens do sistema.',
      disableBeacon: true,
    },
    {
      target: '.updates-tab',
      title: 'Novidades do Sistema',
      content: 'Sempre que lançarmos uma funcionalidade nova ou manutenção, ela aparecerá aqui. Fique de olho no brilho!',
      disableBeacon: true,
    },
    {
      target: '.support-fab',
      title: 'Central de Ajuda',
      content: 'Dúvidas ou problemas? Clique aqui para abrir um chamado com nosso suporte técnico.',
      disableBeacon: true,
    },
    {
      target: '.sidebar-logo',
      title: 'Menu Lateral',
      content: 'Navegue entre Gestão de Frota, Financeiro e Cadastros por aqui.',
      disableBeacon: true,
    },
    {
      target: 'body',
      placement: 'center',
      title: 'Tudo Pronto! 🎉',
      disableBeacon: true,
      content: (
        <div style={{ textAlign: 'center', padding: '10px' }}>
          <p style={{ fontSize: '1.1rem', marginBottom: '15px' }}>
            Você concluiu o tour básico. Agora o <strong>BLB System</strong> está em suas mãos!
          </p>
          
          {/* BOTÃO NUCLEAR: Força o disparo da API ignorando a lib */}
          <button
            type="button"
            onClick={async () => {
              console.log('[TOUR DEBUG] Botão nuclear clicado!');
              try {
                await api.put('/api/usuarios/me/tour', { tour_concluido: 1 });
                alert('✅ Banco de dados atualizado com sucesso! O Tour não vai mais voltar.');
                onComplete?.();
                setRun(false);
                window.location.reload(); // Recarrega a tela para provar que salvou
              } catch (e) {
                console.error('[TOUR DEBUG] Erro na API:', e);
                alert('❌ Falha ao tentar salvar no banco: ' + (e.response?.data?.error || e.message));
              }
            }}
            style={{
              background: '#10b981', color: 'white', border: 'none',
              padding: '12px 20px', borderRadius: '8px', fontWeight: 'bold',
              cursor: 'pointer', width: '100%', fontSize: '1rem', marginTop: '10px'
            }}
          >
            ✅ Entendido, Finalizar e Salvar!
          </button>
        </div>
      ),
    },
  ];

  if (!user || !run) return null;

  return (
    <Joyride
      key={joyrideKey.current}
      steps={steps}
      run={run}
      continuous
      showSkipButton
      scrollToFirstStep
      showProgress
      disableOverlayClose
      spotlightClicks={false}
      locale={{
        back: 'Voltar',
        close: 'Fechar',
        last: 'Ignorar', // Mudei para ignorar pra forçar o usuário a clicar no botão verde
        next: 'Próximo',
        skip: 'Pular Guia',
      }}
      styles={{
        options: {
          primaryColor: '#101C5D',
          backgroundColor: '#ffffff',
          arrowColor: '#ffffff',
          textColor: '#334155',
          zIndex: 10000,
        },
        tooltip: {
          borderRadius: '12px',
          padding: '15px',
          boxShadow: '0 20px 25px -5px rgba(0,0,0,.1), 0 10px 10px -5px rgba(0,0,0,.04)',
        },
        tooltipContainer: { textAlign: 'left' },
        buttonNext: { backgroundColor: '#101C5D', borderRadius: '6px', padding: '8px 16px' },
        buttonBack: { marginRight: '10px', color: '#64748b' },
        buttonSkip: { color: '#94a3b8' },
      }}
      callback={handleJoyrideCallback}
    />
  );
}